import { ClienteDTO, PanelDTO } from "@DTOS";
import {DatosModalPanel} from "../../../layout/saas/crear-desde-archivo-modal/DatosModalPanel";

export namespace PanelsAcciones {
    export class CargarClientes {
        static readonly type = "[Panels] Cargar clientes";
        constructor(public clientes: ClienteDTO[]) {}
    }

    export class Agregar {
        static readonly type = "[Panels] Agregar";
        constructor(public panel: PanelDTO) {}
    }

    export class Actualizar {
        static readonly type = "[Panels] Actualizar";
        constructor(public panel: PanelDTO) {}
    }

    export class Obtener {
        static readonly type = "[Panels] Obtener";
        constructor(public id: number = 0, public cantidad = 10, public pagina = 1) {}
    }

    export class Borrar {
        static readonly type = "[Panels] Borrar";

        constructor(public panel: PanelDTO) {}
    }

    export class CargarResultado {
        static readonly type = "[Panels] Cargar resultado";
        constructor(public panel: PanelDTO, public archivos: FileList, public dashboard: boolean = false) {}
    }

    export class Reiniciar {
        static readonly type = "[Panels] Reiniciar";
    }

    export class ReiniciarEstado {
        static readonly type = "[Panels] Reiniciar estado";
    }

    export class CrearDesdeArchivo {
        static readonly type = "[Panels] Crear desde archivo";
        constructor(public datos: DatosModalPanel, public clientes: ClienteDTO[], public archivos: FileList) {}
    }
}
